import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import VisitorNavbar from './components/VisitorNavbar';
import PermissionCheck from './components/PermissionCheck';
import MainUI from './components/MainUI';
import axios from '../../services/api';

const VisitorPage = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [accessGranted, setAccessGranted] = useState(false);
  const [visitorData, setVisitorData] = useState(null);
  const [ua, setUa] = useState(null);

  const type = searchParams.get('type');
  const lockId = searchParams.get('lockId');

  useEffect(() => {
    if (!type || !lockId) {
      toast.error(t('Invalid URL parameters'));
    } else {
      getVisitorData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, lockId]);

  const getVisitorData = async () => {
    try {
      const response = await axios.get(`/visitor/get-visitor-data/${type}/${lockId}`);
      setVisitorData({ ...response.data.data, sipAccountData: response.data.sipAccount });
    } catch (error) {
      console.error('Error fetching visitor data:', error);
    }
  };

  return (
    <div className="flex flex-col h-screen">
      {visitorData && (
        <VisitorNavbar
          type={type}
          lockId={lockId}
          visitorData={visitorData}
          onSucess={e => {
            setUa(e);
          }}
          onError={() => {
            setUa(null);
          }}
        />
      )}
      {!accessGranted && (
        <PermissionCheck
          type={type}
          lockId={lockId}
          visitorData={visitorData}
          onPermissionSuccess={() => setAccessGranted(true)}
        />
      )}
      {accessGranted && visitorData && (
        <MainUI type={type} lockId={lockId} ua={ua} />
      )}
    </div>
  );
};

export default VisitorPage;
